// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3X78v","modalFooterButton":"ModalNotes_modalFooterButton__2xiX2"};